import { Storage } from "@dashboard-v3/api";

export default function initStorage(): Storage {
  return {
    provider: null,
    authentication: null,
    syncAllByRule: syncAllByRuleDefaultValue,
    userIds: [],
    asUsers: [],
    location: {
      folderStructure: null,
    },
    override: true,
    allManagedUserIds: false,
    retention: null,
  };
}

export const syncAllByRuleDefaultValue = false;
